var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { QRCodeModule } from 'angular2-qrcode';
import { CommonFooterComponent } from './common-footer/common-footer';
import { CommonHeaderComponent } from './common-header/common-header';
import { SanitizerComponent } from './sanitizer/sanitizer';
import { ShopDataComponent } from './shop-data/shop-data';
import { MapComponent } from './map/map';
import { ShopFavoriteComponent } from './shop-favorite/shop-favorite';
import { ScannerComponent } from './scanner/scanner';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ScrollTabComponent } from './scroll-tab/scroll-tab';
import { RssComponent } from './rss/rss';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PushReactionComponent } from './push-reaction/push-reaction';
import { MemberCardComponent } from './member-card/member-card';
var ɵ0 = (createTranslateLoader);
var ComponentsModule = /** @class */ (function () {
    function ComponentsModule() {
    }
    ComponentsModule = __decorate([
        NgModule({
            declarations: [CommonFooterComponent,
                CommonHeaderComponent,
                SanitizerComponent,
                ShopDataComponent,
                MapComponent,
                ShopFavoriteComponent,
                ScannerComponent,
                ScrollTabComponent,
                RssComponent,
                PushReactionComponent,
                MemberCardComponent],
            imports: [
                CommonModule,
                IonicModule,
                DirectivesModule,
                PipesModule,
                QRCodeModule,
                ZXingScannerModule.forRoot(),
                TranslateModule.forChild({
                    loader: {
                        provide: TranslateLoader,
                        useFactory: ɵ0,
                        deps: [HttpClient]
                    }
                }),
            ],
            exports: [CommonFooterComponent,
                CommonHeaderComponent,
                SanitizerComponent,
                ShopDataComponent,
                MapComponent,
                ShopFavoriteComponent,
                ScannerComponent,
                ScrollTabComponent,
                RssComponent,
                PushReactionComponent,
                MemberCardComponent],
            schemas: [CUSTOM_ELEMENTS_SCHEMA]
        })
    ], ComponentsModule);
    return ComponentsModule;
}());
export { ComponentsModule };
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}
export { ɵ0 };
//# sourceMappingURL=components.module.js.map


// WEBPACK FOOTER //
// ./src/components/components.module.ts.pre-build-optimizer.js